import React from 'react';
import { FileText } from 'lucide-react';
import ExportDropdown from '../shared/ExportDropdown';

const ReportLayout = ({ 
  title, 
  subtitle, 
  children, 
  onExportPDF, 
  onExportExcel, 
  onEmailReport,
  loading = false,
  hideExports = false,
  rightActions = null,
  icon: Icon = null,
  iconColor = 'indigo'
}) => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Report Header with Export Dropdown */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {Icon && (
              <div className={`p-2 rounded-lg ${
                iconColor === 'blue' ? 'bg-blue-100' :
                iconColor === 'green' ? 'bg-green-100' :
                iconColor === 'purple' ? 'bg-purple-100' :
                iconColor === 'orange' ? 'bg-orange-100' :
                iconColor === 'red' ? 'bg-red-100' :
                'bg-indigo-100'
              }`}>
                <Icon className={`w-6 h-6 ${
                  iconColor === 'blue' ? 'text-blue-600' :
                  iconColor === 'green' ? 'text-green-600' :
                  iconColor === 'purple' ? 'text-purple-600' :
                  iconColor === 'orange' ? 'text-orange-600' :
                  iconColor === 'red' ? 'text-red-600' :
                  'text-indigo-600'
                }`} />
              </div>
            )}
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              {subtitle && (
                <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
              )}
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex items-center space-x-3">
            {/* Right-side custom actions (e.g., View full report) */}
            {rightActions && (
              <div className="ml-2">{rightActions}</div>
            )}

            {/* Export Dropdown */}
            {!hideExports && (
              <ExportDropdown
                onExportPDF={onExportPDF}
                onExportExcel={onExportExcel}
                onEmailReport={onEmailReport}
                loading={loading}
                disabled={false}
              />
            )}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-6">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            <span className="ml-3 text-gray-600">Loading report data...</span>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default ReportLayout;
